module.exports = __webpack_public_path__ + "static/img/蒙版组 15.049cda9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/declaration/images/蒙版组 15.png
// module id = Rqv7
// module chunks = 0